import React from 'react';
import { motion } from 'framer-motion';
import { Handshake } from 'lucide-react';

const PartnersHero = () => {
  return (
    <section className="relative min-h-[40vh] flex items-center justify-center pt-32">
      {/* Background */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-black via-black/95 to-black/90" />
        <div className="absolute inset-0">
          <div className="absolute inset-0 opacity-20">
            <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,_#1EB899_0%,_transparent_50%)]" />
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative">
        <div className="max-w-3xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="flex items-center justify-center gap-3 mb-6"
          >
            <Handshake className="w-6 h-6 text-accent" />
            <span className="text-accent text-lg">Strategic Partnerships</span>
          </motion.div>
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-4xl md:text-5xl font-display font-semibold text-white mb-4 leading-[1.2]"
          >
            Powering Innovation Together
          </motion.h1>
        </div>
      </div>
    </section>
  );
};

export default PartnersHero;